import { gql } from '@apollo/client';

const SIGNED_URLS_FRAGMENT = gql`
  fragment SignedUrlsFragment on SignedUrlFile {
    path
    pipeFrom
    thumbnailUrl
    thumbnailPipeFrom
    urls
    error
    documentId
    id
  }
`;

export default SIGNED_URLS_FRAGMENT;
